import { important } from '../../styles/tools/parsers'
import grid from '../../styles/tools/grid'

export default ({ colors, fontFamilies, fontWeights }) => ({
  globals: {
    '*.rc-collapse': {
      'min-height': '21rem',
      marginBottom: '1rem',

      border: '0',
      backgroundColor: colors.requestList.content.bg
    },

    '*.rc-collapse-header': {
      fontFamily: fontFamilies.default,
      fontWeight: fontWeights.requestList.header,
      lineHeight: important('2.7rem'),

      color: important(colors.requestList.header.text)
    },

    '*.rc-collapse-item .arrow': {
      float: important('right'),

      marginTop: important('16px'),
      marginRight: important('16px'),

      borderTop: important('4px solid transparent'),
      borderBottom: important('4px solid transparent'),
      borderLeft: important(`6px solid ${colors.requestList.header.text}`)
    },

    '*.rc-collapse-item-active .arrow': {
      float: important('right'),

      marginTop: important('18px'),
      marginRight: important('16px'),

      borderTop: important(`6px solid ${colors.requestList.header.text}`),
      borderBottom: important('4px solid transparent'),
      borderLeft: important('4px solid transparent')
    },
    '*.rc-collapse-content-box': {
      position: 'relative'
    }
  },

  detail: {
    border: `1px solid ${colors.requestList.header.border}`,
    borderRadius: '4px',
    backgroundColor: colors.requestList.header.bg
  },

  label: {
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '1.5',
    color: colors.label.default
  },

  value: {
    display: 'inline',
    fontSize: '1rem',
    lineHeight: '1.5',
    color: colors.common.body.text.default
  },

  listColumn: {
    ...grid({ colSpan: 6, columns: 12 })
  },
  listColumnButtons: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    position: 'absolute',
    height: '100%',
    right: '0'
  }
})



// WEBPACK FOOTER //
// ./components/requests/styles.js